import React, { createRef, useEffect, useRef, useState } from 'react'
import styles from './SportTypesContainer.module.css'
import { Sports } from '../types'
import SportTypes from './SportTypes'
import NoLiveSportTypes from './NoLiveSportTypes'
import { SHOW_SPORTS_COUNT_TYPES } from '../../../app/const'
import _ from 'lodash'
import { useHistory, useParams } from 'react-router-dom'

interface UrlParams {
  urlSportType: string
}

interface Props {
  sportTypes: Sports[]
  currentSportType: string
  scrollTopLiveList: (index: number) => void
  urlSportType: string
}

const SportTypesContainer = ({
  sportTypes,
  currentSportType,
  scrollTopLiveList,
}: Props) => {
  const history = useHistory()  
  const { urlSportType } = useParams<UrlParams>()

  const sportTypesRef = useRef() as React.MutableRefObject<HTMLDivElement>
  //const sportTypeRefs = useRef([])// as React.MutableRefObject<HTMLDivElement>[]

  const SportTypesLength = SportTypes.length
  const [sportTypeRefs, setSportTypeRefs] = useState([])

  React.useEffect(() => {
    setSportTypeRefs((sportTypeRefs) =>
      Array(SportTypesLength)
        .fill(0)
        .map((_, i) => sportTypeRefs[i] || createRef())
    )
  }, [SportTypesLength])

  const [sportTypesArrows, setSportTypesArrows] = useState([true, false])
  const [sportTypesScroll, setSportTypesScroll] = useState<number | null>(null)

  useEffect(() => {
    if (sportTypesRef?.current && urlSportType && sportTypesScroll === null) {
      const index = _.findIndex(sportTypes, (s) => s.Id === currentSportType)
      sportTypesRef.current.scrollTo(index * 86, 0)
    }
  }, [urlSportType,currentSportType, sportTypes, sportTypesScroll])

    history.listen(() => {
      if (sportTypesScroll === null) setSportTypesScroll(0)
    })

  const onSportTypesScroll = () => {
    const element = sportTypesRef?.current
    if (element) {
      setSportTypesScroll(element.scrollLeft)

      const maxScrollLeft = element.scrollWidth - element.clientWidth
      setSportTypesArrows([
        element.scrollLeft === 0,
        element.scrollLeft === maxScrollLeft,
      ])
    }
  }

  return sportTypes?.length > 0 ? (
    <div
      className={`${styles.sportTypeContainer} ${
        sportTypesArrows[0] ? '' : styles.leftArrow
      } ${sportTypesArrows[1] ? '' : styles.rightArrow}`}
      ref={sportTypesRef}
      onScroll={onSportTypesScroll}
    >
      {sportTypes.map((sport: Sports) => (
        <SportTypes
          key={sport.Id}
          Id={sport.Id}
          ref={sportTypeRefs[Number(sport.Id)]}
          IsTopLeague={sport.IsTopLeague}
          HasTopLeague={sport.HasTopLeague}
          Active={sport.Id === String(currentSportType) ? 'active' : ''}
          SportTypeName={sport.SportTypeName}
          hasSportCount={SHOW_SPORTS_COUNT_TYPES.includes(Number(sport.Id))}
          CurrentGameCount={sport.CurrentGameCount}
          UpcomingGameCounts={sport.UpcomingGameCounts}
          scrollTopLiveList={scrollTopLiveList}
        />
      ))}
    </div>
  ) : (
    <NoLiveSportTypes />
  )
}

export default React.memo(SportTypesContainer)